import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b5b08d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-input-btn d-flex gap-2 align-items-center justify-content-between"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus list-input-btn__addicon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-1" }, " Add a Card ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-card-image rounded-1 list-input-btn__template btn-icon",
  role: "button"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kanban_add_form = _resolveComponent("kanban-add-form")!

  return (!_ctx.showInput)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn list-input-btn__btn d-flex gap-1 justify-content-between px-2 py-1 text-start shadow-none w-100",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInput = true))
        }, _hoisted_4),
        _hoisted_5
      ]))
    : (_openBlock(), _createBlock(_component_kanban_add_form, {
        key: 1,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInput = false)),
        onSubmit: _ctx.handleAddTask
      }, null, 8, ["onSubmit"]))
}